<template>
  <div>
    <div v-if="model===false">
      <div class="total" ref="total">
        <div class="topback"
             :style="{ height: '6vh', backgroundColor: scrollback ? 'rgb(245 244 246)' : 'rgb(245 244 246)' ,position:'fixed'}" v-if="!isMerge">
          <headtip  :changeVisable="changeVisable" @showDialog="showPartner"></headtip>
        </div>
        <div @click="changeheadVisable">
          <div class="screen1">

          <kefu @toptop="topTop"></kefu>
          <!--      logo  you气通GPT社区 合作伙伴  登录-->

          <!--       油气通GPT 全球油气行业最专业的、开放的大模型人工智能云平台-->
          <div class="layer2">
            <div v-sliden-instep="{duration:800}" class="title1" style="font-weight: bolder">生产工艺优化软件</div>
            <div v-sliden-instep="{duration:1200}" class="title2" style="font-weight: bolder">
             借助AI模型优化生产工艺，提高开发效率，降低风险损失，保障油气田开发安全稳定
            </div>
            <div v-sliden-instep="{duration:1600}" class="title4">*油气人工智能模型的泛化能力有限，实际应用中可能需根据具体场景和需求进行适配和优化。如您有合作意向或产品咨询，请随时与我们联系。

              <span v-sliden-instep="{duration:2000}" style="color: #eb7c31;font-weight: bolder"><br>①&nbsp;工艺类服务，由安东石油线下技术人员提供服务<br>②&nbsp;GPT开发服务，由安东人工智能专业技术人员提供服务</span>
            </div>
            <div class="titlle3" @click="clickConsult('油气通')" style="font-weight:bolder">
              产品咨询
            </div>
          </div>
          <!--      平台大图-->
          <div class="layer3"></div>
        </div>
        <div class="screenmake2">
<!--          <transition name="run" appear>-->
          <div v-sliden-instep="{duration:2000}" class="heighLight"><span>生产工艺优化软件开发</span></div>
<!--          </transition>-->
          <div class="grid">
            <!--            <div class="card1" @click="detail1()">-->
            <a href="/Stratum" target="_blank">
              <transition name="rundown1" appear>
            <div v-sliden-in="{duration:800}" class="card">
              <div class="back">
                <div class="imgDesign">
                  <img loading="lazy" src="@/assets/gpt23.png">
                </div>
                <div class="titleDesign">
                  <div class="Title1"> 智能分析地质分层</div>
                  <div class="Title2" style="overflow: hidden;">
                    <li>模型可综合运用MWD和LWD数据，实时分析地质分层信息；</li>
                    <li>根据预设阈值自动生成预警信息，辅助工程人员及时调整钻井参数；</li>
                  </div>
                  <div class="backconsult">
                    免费体验
                  </div>
                  <div class="backconsultArrow">
                    点击查看<i style="font-size:14px;margin-left: 15px;" class="el-icon-right"></i>
                  </div>
                </div>
              </div>


            </div>
              </transition>
            </a>
            <a href="/frack" target="_blank">
              <transition name="rundown2" appear>
            <div v-sliden-in="{duration:1500}" class="card" >
              <div class="back">
                <div class="imgDesign">
                  <img loading="lazy" src="@/assets/gpt33.png">
                </div>
                <div class="titleDesign">
                  <div class="Title1"> 智能预测预计采收储量</div>
                  <div class="Title2">

                    <li>智能预测采收储量（EUR）</li>
                    <li>影响压裂的工程参数和地质参数进行相关性分析</li>

                  </div>
                  <div class="backconsult">
                    免费体验
                  </div>
                  <div class="backconsultArrow">
                    点击查看<i style="font-size:14px;margin-left: 15px;" class="el-icon-right"></i>
                  </div>
                </div>
              </div>


            </div>
              </transition>
            </a>
            <a href="/drilling" target="_blank">
              <transition name="rundown3" appear>
            <div  v-sliden-in="{duration:2000}" class="card"  style="cursor: pointer">
              <div class="back">
                <div class="imgDesign">
                  <img loading="lazy" src="@/assets/gpt15.png">
                </div>
                <div class="titleDesign">
                  <div class="Title1"> 钻井施工参数生成</div>
                  <div class="Title2">

                  <li>利用模型获取适宜的钻井钻压、钻速、泵压等可调参数</li>
                  </div>
                  <div class="backconsult">
                    免费体验
                  </div>
                  <div class="backconsultArrow">
                   点击详情 <i style="font-size:14px;margin-left: 15px;" class="el-icon-right"></i>
                  </div>
                </div>
              </div>
            </div>
              </transition>
            </a>
            <a href="/alarm" target="_blank">
            <div v-sliden-in="{duration:800}" class="card" >
              <div class="back">
                <div class="imgDesign">
                  <img loading="lazy" src="@/assets/alarmopen.png">
                </div>
                <div class="titleDesign">
                  <div class="Title1"> 地层压力异常报警</div>
                  <div class="Title2">
                    <li>实时监控钻井参数，通过钻井数据实时计算DC指数，精准预测地层压力，对钻井异常及时预警</li>
                  </div>
                  <div class="backconsult">
                    免费体验
                  </div>
                  <div class="backconsultArrow">
                    点击查看<i style="font-size:14px;margin-left: 15px;" class="el-icon-right"></i>
                  </div>
                </div>
              </div>
            </div>
            </a>
            <a href="/plug" target="_blank">
            <div v-sliden-in="{duration:1500}" class="card" >
              <div class="back">
                <div class="imgDesign">
                  <img loading="lazy" src="@/assets/gpt34.png">
                </div>
                <div class="titleDesign">
                  <div class="Title1"> 砂堵报警</div>
                  <div class="Title2">
                    <li>动态监测和预警砂堵风险</li>
                  </div>
                  <div class="backconsult">
                    免费体验
                  </div>
                  <div class="backconsultArrow">
                    点击查看<i style="font-size:14px;margin-left: 15px;" class="el-icon-right"></i>
                  </div>
                </div>
              </div>
            </div>
            </a>
            <!--            <div class="card1" @click="detail3()">-->
            <div v-sliden-in="{duration:2000}" class="card">
              <div class="back">
                <div class="imgDesign">
                  <img loading="lazy" src="@/assets/gpt43.png">
                </div>
                <div class="titleDesign">
                  <div class="Title1"> 智能注采决策</div>
                  <div class="Title2">
                    为提高注水开发效率，施工人员需要将智能分层注水系统与智能分层采油系统相结合，通过注采联动，实时监控智能分层注水和智能分层采油情况，对各层系注水量、产液量、含水率、压力等情况进行动态对比分析，提高油藏调控的针对性与灵活性，提高注水方案执行率。
                  </div>
                  <div class="backconsult">
                    模型开发中...
                  </div>
<!--                  <div class="backconsultArrow">-->
<!--                    点击查看<i style="font-size:14px;margin-left: 15px;" class="el-icon-right"></i>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
            <!--            <div class="card1" @click="detail4()" style="cursor: pointer">-->
            <div v-sliden-in="{duration:800}" class="card">
              <div class="back">
                <div class="imgDesign">
                  <img loading="lazy" src="@/assets/gpt53.png">
                </div>
                <div class="titleDesign">
                  <div class="Title1"> 油气田视频监控</div>
                  <div class="Title2">
                    实现现场违章行为的实时抓取、智能识别与主动预警，还大幅节约监督人力资源，提升监管质效，有效防控安全风险，电子沙盘实施感知风险，优化了人员调配，同时客观上也提高了安全意识，规范了安全行为。
                  </div>
                  <div class="backconsult">
                    模型开发中...
                  </div>
<!--                  <div class="backconsultArrow">-->
<!--                    点击查看<i style="font-size:14px;margin-left: 15px;" class="el-icon-right"></i>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
            <div v-sliden-in="{duration:1500}" class="card">
              <div class="back">
                <div class="imgDesign">
                  <img loading="lazy" src="@/assets/gpt44.png">
                </div>
                <div class="titleDesign">
                  <div class="Title1">人工举升优化</div>
                  <div class="Title2">
                    人工举升的作用是将油气开采至地面，是原油开采中的重要环节。油井在井身结构、产量、流体性质等方面差异促进了人工举升技术的多元化发展。举升智能优化合实时井口监测方案，通过减缓油田产量的下降率，可以最大程度提高油井收益。
                  </div>
                  <div class="backconsult">
                    模型开发中...
                  </div>
<!--                  <div class="backconsultArrow">-->
<!--                    点击查看<i style="font-size:14px;margin-left: 15px;" class="el-icon-right"></i>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
            <div v-sliden-in="{duration:2000}" class="card">
              <div class="back">
                <div class="imgDesign">
                  <img loading="lazy" src="@/assets/gpt45.png">
                </div>
                <div class="titleDesign">
                  <div class="Title1"> 机采智能管控</div>
                  <div class="Title2">
                    以物联网数据为基础，结合大数据技术、工况诊断技术及机采提效优化技术，深度挖掘海量数据的潜在价值，可实现稀油机采井运行状况和能耗的整体管控。
                  </div>
                  <div class="backconsult">
                    模型开发中...
                  </div>
<!--                  <div class="backconsultArrow">-->
<!--                    点击查看<i style="font-size:14px;margin-left: 15px;" class="el-icon-right"></i>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
            <div v-sliden-in="{duration:800}" class="card">
              <div class="back">
                <div class="imgDesign">
                  <img loading="lazy" src="@/assets/gptModel53.png">
                </div>
                <div class="titleDesign">
                  <div class="Title1"> 油气田能耗优化</div>
                  <div class="Title2">
                    推进机采、注水、集输、电力四大生产系统节能降耗，推动提质增效。通过“关、停、并、转、减”，以及井筒工艺优化、机采井调平衡、低产井间开等措施，实现机采系统节电，实施电力系统配电减容、更换节能电机等措施，节约电能消耗。
                  </div>
                  <div class="backconsult">
                    模型开发中...
                  </div>
<!--                  <div class="backconsultArrow">-->
<!--                    点击查看<i style="font-size:14px;margin-left: 15px;" class="el-icon-right"></i>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
            <div v-sliden-in="{duration:1500}" class="card">
              <div class="back">
                <div class="imgDesign">
                  <img loading="lazy" src="@/assets/gpt55.png">
                </div>
                <div class="titleDesign">
                  <div class="Title1"> 生产调度策略优化</div>
                  <div class="Title2">
                    石油开采和加工的过程比较复杂，工序繁多，涉及的范围广，油田企业日常生产过程需要有计划的安排，这就需要发挥油田利用AI技术实现智能运行调度的作用，规划好油田企业的各项工作，保证企业生产和施工有序、高效的进行。
                  </div>
                  <div class="backconsult">
                    模型开发中...
                  </div>
<!--                  <div class="backconsultArrow">-->
<!--                    点击查看<i style="font-size:14px;margin-left: 15px;" class="el-icon-right"></i>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
            <div  v-sliden-in="{duration:2000}" class="card">
              <div class="back">
                <div class="imgDesign">
                  <img loading="lazy" src="@/assets/gpt64.png">
                </div>
                <div class="titleDesign">
                  <div class="Title1"> 设备故障主动预警</div>
                  <div class="Title2">
                    在线监测系统可以分析设备的工作状态，预测设备的故障，并及时报警，避免设备故障导致的停工和维修时间延长。
                  </div>
                  <div class="backconsult">
                    模型开发中...
                  </div>
<!--                  <div class="backconsultArrow">-->
<!--                    点击查看<i style="font-size:14px;margin-left: 15px;" class="el-icon-right"></i>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="screenmake3">
          <div class="heighLight">成功案例</div>
          <div class="grid">
            <el-carousel indicator-position="outside" arrow="always" interval="5000">
              <el-carousel-item v-for="item in success" :key="item">
                <div class="card">
                  <div class="back">
                    <div v-left-in="{duration:800}"  class="imgDesign">
                      <img loading="lazy" :src="item.img"/>
                    </div>
                    <div v-left-in="{duration:800}"  class="titleDesign">
                      <div class="title1">{{ item.title1 }}</div>
                      <div class="title2" v-html="item.title2"></div>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
          <bottomTip v-if="!isMerge"></bottomTip></div>
        <partnerTip
            :dialogVisible="dialogconsult"
            @hideDialog="hide"
        ></partnerTip>
        <consultTip
            :dialogVisible="dialogVisible"
            :thisTitle="title"
            @hideDialog="hideDialog"
        ></consultTip>
      </div>
    </div>
    <div v-else>
      <div class="totalModel"  ref="totalModel">
        <div class="screen1">
          <kefuMobile @topMobile="topTopmobile"  v-if="!isMerge"></kefuMobile>
          <headtip @showDialog="showPartner"  v-if="isShowHead"></headtip>
          <!--      logo  you气通GPT社区 合作伙伴  登录-->

          <!--       油气通GPT 全球油气行业最专业的、开放的大模型人工智能云平台-->
          <div class="layer2">
            <div class="title1">设计GPTs</div>
            <div class="title2">基于油藏地质知识智能解释处理、为智能钻井压裂等应用场景提供油藏地质设计</div>


          </div>
          <div class="titlle3" @click="clickConsult('油气通')" style="font-weight:bolder">
            产品咨询
          </div>
          <div class="title4">
            *油气人工智能模型的泛化能力有限，实际应用中可能需根据具体场景和需求进行适配和优化。如您有合作意向或产品咨询，请随时与我们联系。
          </div>
          <!--      平台大图-->
          <div class="layer3"></div>
        </div>
        <div class="screenmake0">
          <div class="heighLight">油藏地质模型架构</div>
          <div class="heightLight2">
            以油藏地质研究及各个应用场景数据为中心，通过解释脑形成知识成果，智能优化油藏地质研究成果，从而达到油藏地质知识智能解释处理、为智能钻井压裂等应用场景提供油藏地质知识的目的。
          </div>
          <div class="grid">
            <div class="card1">
              <div class="back">
                <div class="imgDesign">
                  <img loading="lazy" src="@/assets/gptModel12.png">
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="screenmake2">
          <div class="heighLight"><span>油藏地质GPTs</span></div>
          <div class="grid">
            <div class="card">
              <div class="back">
                <div class="imgDesign"></div>
                <div class="titleDesign">
                  <div class="Title1"><span
                      style="background-color: #FF6400;border-radius: 50%; width:16px;font-size:16px;height:16px;display: flex;justify-content: center;align-items: center;color: white;margin-top: 4px">1</span>&nbsp;储层识别/岩性识别
                  </div>
                  <div class="Title2">
                    油气储层是在油气勘探工程中，地下存在油气聚集的岩层区域。储层的特征包括了岩性、物性、含油气性等方面，这也是储层预测的主要方向。储层岩性是描述储层矿物质组成成分的主要特征，反映了岩层的储藏性能和储层特征，常用参数包括储层岩石物理结构、分布范围、储层顶界面构造形态、储层厚度等。综合储层特征，实现对油气富集区域即甜点进行预测，为油气钻探指明位置和开采方案。
                  </div>
                  <!--                  <div class="backconsult">-->
                  <!--                    免费体验-->
                  <!--                  </div>-->
                  <!--                  <div class="backconsultArrow">-->
                  <!--                    <i style="font-size:14px;margin-left: 15px;" class="el-icon-right"></i>-->
                  <!--                  </div>-->
                </div>
              </div>
            </div>
            <div class="card1">
              <div class="back">
                <div class="imgDesign"></div>
                <div class="titleDesign">
                  <div class="Title1"><span
                      style="background-color: #FF6400;border-radius: 50%; width:16px;font-size:16px;height:16px;display: flex;justify-content: center;align-items: center;color: white;margin-top: 4px">2</span>&nbsp;基于压裂参数的EUR预测及参数反推平台
                  </div>
                  <div class="Title2">
                    通过先进的数据分析技术，结合压裂参数，为您分析最终可采储量。不仅如此，系统还能根据EUR值反向推算关键参数，实现历史记录的深度挖掘和相关性分析，帮助您优化油藏管理和提高采收效率。
                  </div>
                </div>
              </div>
            </div>
            <div class="card2">
              <div class="back">
                <div class="imgDesign"></div>
                <div class="titleDesign">
                  <div class="Title1"><span
                      style="background-color: #FF6400;border-radius: 50%; width:16px;font-size:16px;height:16px;display: flex;justify-content: center;align-items: center;color: white;margin-top: 4px">3</span>&nbsp;地质甜点/工程甜点识别
                  </div>
                  <div class="Title2">
                    油气勘探开发的过程中，会揭示大面积的含油气区及大段的含油气层段，但是往往其中一部分是具有当前经济、技术条件下具有较好开发效益的部分，称之为“甜点”。以实测地质参数、工程参数为输入，利用神经网络模拟技术，通过大数据智能分析地质参数与弹性参数的相关关系，解译出相应的甜点评价参数。
                  </div>
                </div>
              </div>


            </div>
          </div>

        </div>
        <div class="screenmake3">
          <div class="heighLight">成功案例</div>
          <div class="grid">
            <el-carousel indicator-position="outside" arrow="always" interval="5000">
              <el-carousel-item v-for="item in 1" :key="item">
                <div class="card">
                  <div class="back">
                    <div class="imgDesign">
                      <img loading="lazy" src="@/assets/gpt16.png">
                    </div>
                    <div class="titleDesign">
                      <div class="title1">XX地区页岩气井实施方案优化、实时跟踪及综合效果评价</div>
                      <div class="title2">1.精细三维地应力预测及裂缝检测</div>
                      <div class="title2">2.新井精细跟踪服务</div>
                      <div class="title2">3.老井生产动态跟踪分析及评价</div>
                    </div>
                  </div>


                </div>


              </el-carousel-item>
            </el-carousel>
          </div>

        </div>
        <bottomTip v-if="!isMerge"></bottomTip>
        <partnerTip
            :dialogVisible="dialogconsult"
            @hideDialog="hide"
        ></partnerTip>
        <consultTip
            :dialogVisible="dialogVisible"
            :thisTitle="title"
            @hideDialog="hideDialog"
        ></consultTip>
      </div>
    </div>
  </div>


</template>


<script>

import headtip from "@/views/headTip.vue";
import kefu from "@/views/kefu.vue";
import kefuMobile from "@/views/kefuMobile.vue";
import PartnerTip from "@/components/partnerTip.vue";
import consultTip from "@/components/consultTip.vue";
import bottomTip from "@/views/bottomTip.vue";
import {shareUrl} from "@/utils/vxshare";
import {vSlidenIn} from '@/utils/vSlidenIn.js'; // 确保路径正确
import {vZoomIn} from '@/utils/vZoomIn.js'; // 确保路径正确
import {vLeftIn} from '@/utils/vLeftIn.js'
import {vSlidenInstep} from '@/utils/vSlidenInstep.js';
export default {

  name: "",

  props: {
    isMerge: {
      type: Boolean,
      default: false
    },
    isShowHead: {
      type: Boolean,
      default: true
    }
  },

  components: {bottomTip, consultTip, PartnerTip, headtip, kefu, kefuMobile},
  directives: {
    slidenIn: vSlidenIn,
    zoomIn: vZoomIn,
    leftIn:vLeftIn,
    slidenInstep:vSlidenInstep
  },
  data() {
    return {
      changeVisable:1,
      title: '',
      pageTitle: '生产工艺优化GPTs_油气行业工艺类大模型人工智能应用-油气通GPT',
      pageDescription: '油气通GPT云平台提供生产工艺优化GPTs，不仅有助于提高开发效果和采收率，同时降低开发过程中的风险损失，确保油气田的安全稳定开发。',
      pageKeywords: '工艺GPTs，生产工艺优化GPTs，智能分析地质分层，智能注采决策，油气田视频监控，地层压力异常工况报警平台，人工举升优化，机采智能管控，油气田能耗优化，油气通，油气通GPT，油气通GPT云平台，油气通大模型，油气通GPT大模型',
      scrollback: false,
      model: false,
      dialogconsult: false,
      dialogVisible: false,
      success: [
        {
          img: require("@/assets/gpt26.png"),
          title1: "XX深层煤层气钻井项目",
          title2: "安东自2022年三季度进入xx煤项目施工，2部钻机（50LDB带顶驱）参与，共施工10口深层煤层气水平井，平均井深3530m，水平段长1000-1500m，平均钻井周期30.48天（最短27.58天），多口单井或开次创区块记录，得到客户高度认可。",
        },
        {
          img: require("@/assets/gpt46.png"),
          title1: "智能采油机器人服务",
          title2: "        <li style=\"margin-top: 1vh\">针对抽油机井，实时采集压力温度、电参、示功图、动液面等数据，输入到智能采油机器人工艺脑，输出得到最优化生产运行参数，减少无效冲次，杜绝空抽，使抽油机在最佳工况下运行，油井能够保持动液面稳定，达到了油井供采平衡，实现了油井的稳产增产。</li>\n" +
              "                        <li style=\"margin-top: 0.5vh\">应用业绩：分别在大港油田、华北油田、胜利油田、中原油田、江汉油田以及延长石油开展智能采油机器人工业现场应用测试，运行稳定，取得较好的应用效果。</li>",
        },
        {
          img: require("@/assets/gpt56.png"),
          title1: "XX石油天然气脱烃增压智慧场站项目",
          title2: "<span style=\"margin-top: 3vh;font-weight: bold\">设备检测，精准实时：</span><br>  " +
              "根据智能化目标需求，配套高效新技术新产品，通过现场集成应用，全天候实时监测设备运行状况<br> <span style=\"font-weight: bold\">方案成果：</span>  <li>降低维护成本: 及时发现潜在故障和问题，使维护更加预防性和精确，降低维护成本；</li>\n" +
              "                        <li style=\"margin-top: 0.5vh\">增强设备可靠性: 减少设备故障和停机时间，提高设备的寿命；</li>\n" +
              "                        <li style=\"margin-top: 0.5vh\">优化资源利用: 实时监测和数据分析帮助更好地利用资源，包括能源、原材料和人力资源，降低成本。</li>",
        },
      ]
    }

  },

  methods: {     topTopmobile() {
      console.log("fuzujianchuanzhi")
      //const element = this.$refs.total;
      //const rect = element.offsetTop + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    },
    topTop() {
      console.log("fuzujianchuanzhi")
      // const element = this.$refs.total;
      // const rect = element.offsetTop + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    },    changeheadVisable(){
      if(this.changeVisable===1){
        this.changeVisable=0
      }
      else{
        this.changeVisable=1
      }
      console.log("父组件", this.changeVisable)
    },

    clickConsult(item) {

      this.title = item
      this.dialogVisible = true;
      sessionStorage.setItem('title', item)
    },
    setMetaTags() {
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', this.pageDescription);
      }

      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', this.pageKeywords);
      }
    },
    detail1() {
      window.open("/ground", "_blank");
    },
    detail2() {
      window.open("/frack", "_blank");
    }, detail12() {
      window.open("/Stratum", "_blank");
    },

    detail3() {
      window.open("/decision", "_blank");
    }, detail13() {
      window.open("/plug", "_blank");
    },
    detail4() {
      window.open("/monitor", "_blank");
    },
    detail5() {
      window.open("/alarm", "_blank")
    },
    detail6() {
      window.open("/drilling", "_blank")
    },

    showPartner() {
      this.dialogconsult = true;
    },

    hideDialog() {
      this.dialogVisible = false;
    },
    hide() {
      this.dialogconsult = false;
    },
    handleScroll() {
      if (this.model === false) {
        this.scrollHeight = this.$refs.total.scrollTop;
      } else {
        this.scrollHeight = this.$refs.totalModel.scrollTop;
      }

      if (this.scrollHeight < 100) {
        this.scrollTrue = true
      } else {
        this.scrollTrue = false
      }
      if (this.scrollHeight < 500) {
        this.scrollback = false
      } else {
        this.scrollback = true
      }
      console.log("gaodu", this.scrollHeight < 100)
    },
  },
  beforeDestroy() {

    this.$refs.total.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    this.$refs.total.addEventListener('scroll', this.handleScroll);
    
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

// Log the values1731 809   1653 834   1912 932
    console.log("Screen Width: ", screenWidth);
    console.log("Screen Height: ", screenHeight);
    if (screenWidth <= 700) {
      this.model = true
    } else {
      this.model = false
    }
  },
  created() {

    document.title = this.pageTitle;
    this.setMetaTags();
    
    localStorage.setItem("home", 0)
    let url = window.location.href
    // let url = 'https://oilgasinfoai.com/?language=zh'
    setTimeout(() => {
      //encodeURIComponent 将你的URL进行转译一下，因为微信分享出去后会带有多余用不到的参数
      let shareData = {
        url: url,
        pageTitle: '生产工艺优化GPTs_油气行业工艺类大模型人工智能应用-油气通GPT',
        pageDescription: '油气通GPT云平台提供生产工艺优化GPTs，不仅有助于提高开发效果和采收率，同时降低开发过程中的风险损失，确保油气田的安全稳定开发。',
        pageKeywords: '工艺GPTs，生产工艺优化GPTs，智能分析地质分层，智能注采决策，油气田视频监控，地层压力异常工况报警平台，人工举升优化，机采智能管控，油气田能耗优化，油气通，油气通GPT，油气通GPT云平台，油气通大模型，油气通GPT大模型',
      };
      shareUrl(shareData);
    }, 1000);
  },

}

</script>


<style type="text/scss" lang="scss" scoped>
.total {
  background: #ebf1fd;
  overflow-x: hidden;
  width: 100vw;
  //height: 100vh;
  position: relative;

 .topback{
    position: fixed;
    z-index:999;
    width: 100vw;
    padding: 0 0 0 2.86077411900635vw;
  }

  .screen1 {
    z-index: 3;
    position: relative;
    width: 100%;
    height: 74vh;
    padding: 6.84301606922126vh 2.86077411900635vw 2.84301606922126vh 6.86077411900635vw;
    background-image: url("../../assets/gpt21.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: transparent;
    /* Add any additional styling as needed */

    .layer2 {
      margin-top: 3vh;
      margin-left: 2vw;

      .title1 {
        width: fit-content;
        height: 7.77626699629172vh;
        font-size: 2.5vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #2f6eff;
        line-height: 12.23733003708282vh;
      }

      .title2 {
        margin-top: 4.82076637824475vh;
        width: 35vw;
        height: fit-content;
        text-align: justify;
        font-size: 1.3vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #2f6eff;
        line-height: 5vh;
      }

      .title4 {
        margin-top: 3vh;
        width: 35vw;
        font-size: 1vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        line-height: 5vh;
      }

      .titlle3 {
        position: absolute;
        bottom: 7.78739184177998vh;
        margin-top: 4.07911001236094vh;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.2vw;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: bolder;
        color: #ffffff;
        line-height: 3.3374536465vh;
        text-align: center;
        border-radius: 9px;
        width: fit-content;
        padding: 2.4624227441vh 1.1989601386vw;
        height: 4.5624227441vh;
        background: #2f6eff;
        border: #2f6eff 1px solid;

      }

      .titlle3:hover {

        color: #2168DB;
        border: #2168DB 1px solid;
        background: rgba(255, 255, 255, 0.5);
      }
    }

    //.layer3 {
    //  position: absolute;
    //  top: 5.06798516687268vh;
    //  right: 11.61178509532062vw;
    //  width: 47.42923165800116vw;
    //  height: 72.80593325092707vh;
    //  background-image: url("../assets/GPTplant.png");
    //  background-size: 100% auto;
    //  background-position: center;
    //  background-repeat: no-repeat;
    //  background-color: transparent;
    //  opacity: 1;
    //}
  }

  .screenmake2{
    padding: 7.78739184177998vh 9.09763142692085vw;
    width: 100%;
    height: fit-content;
    background: white;

    .run-enter-active {
      animation: fadeInDown 1s ease-in-out both;
    }
    .rundown1-enter-active {
      animation: slideInUp 1s ease-in-out both;
    }
    .rundown2-enter-active {
      animation: slideInUp 1.2s ease-in-out both;
    }
    .rundown3-enter-active {
      animation: slideInUp 1.4s ease-in-out both;
    }
    .heighLight{
      display: flex;
      //justify-content: center;
      text-align: left;
      height:8.23733003708282vh;
      font-size:2.3vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: bold;
      color: #111111;
      line-height: 4.23733003708282vh;
    }


    .grid{
      margin-top:2.78739184177998vh ;
      display: grid;
      grid-template-columns: minmax(0,1fr) minmax(0,1fr) minmax(0,1fr);
      column-gap:15px;
      .card {
        //cursor: pointer;
        width: 100%;
        height: fit-content;
        padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0;
        opacity: 1;
        overflow: hidden; /* 防止子元素的绝对定位导致的问题 */
        .back {
          border-radius: 9px;
          position: relative;
          border: 2px solid white;
          box-shadow: 5px 0 14px 0px #D4E4FF;
          height: fit-content;
          min-height: 70vh;
          overflow: hidden;
          transition: transform 0.8s ease-out, height 0.8s ease-out;
          background: #015377;
        }
        .imgDesign {
          overflow: hidden;
          width: 100%;
          height: 38vh;
          background-position: center;
          background-size: cover;
          background-repeat: no-repeat;
          background-color: transparent;
          transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out, transform 0.5s ease-in-out;
          visibility: visible;
        }
        .titleDesign {
          position: absolute;
          height: 30vh;
          bottom: 2vh;
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 2vh;
          max-height: 27vh;
          transition: max-height 0.5s ease-out,min-height 0.5s ease-out;
          .Title1 {
            margin: 0vh 1.8597920277vw 0 1.8597920277vw;
            text-align: left;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; /* 限制在一个块元素显示的文本的行数 */
            overflow: hidden;
            text-overflow: ellipsis;
            height: 5vh;
            font-size: 1.6vw;
            font-family: Sarial, sans-serif, "Microsoft Yahei";
            font-weight: 700;
            transition: transform 0.8s ease-out;
            color: white;
            line-height: 4vh;
          }
          .Title2 {
            color: white;
            opacity: 1;
            max-height: 14vh;
            overflow: hidden;
            transition: opacity 0.5s ease-out;
            margin: 0 1.8597920277vw 5vh 1.8597920277vw;
            font-size: 1.1vw;
            font-family: Sarial, sans-serif, "Microsoft Yahei";
            font-weight: 400;
            line-height: 4.5vh;
            flex-grow: 1;

            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow:hidden;
          }
          .backconsult {
            position: absolute;
            bottom: 1vh;
            width: 100%;
            left: 0px;

            text-align: center;
            font-size: 1.1vw;
            font-family: Sarial, sans-serif, "Microsoft Yahei";
            font-weight: bolder;
            color: #ef9729;
            align-items: center; /* Vertically center the text */
            justify-content: center; /* Horizontally center the text */
            height: 2.95414091470952vh;
            right: 1.8597920277vw;
          }
          .backconsultArrow {
            transition: opacity 0.5s ease-out;
            opacity: 0;
            position: absolute;
            bottom: 1.81248454882571vh;
            text-align: center;
            font-size: 1.1vw;
            font-family: 'Times New Roman';
            font-weight: 400;
            color: #ef9729;
            align-items: center; /* Vertically center the text */
            justify-content: center; /* Horizontally center the text */
            height: 2.95414091470952vh;
            left: 1.8597920277vw;
          }
        }
      }


      .card:hover {
        .imgDesign {
          //opacity: 0;
          //visibility: hidden;
          transform: scale(1.05);
        }

        .titleDesign{
          transform: scale(1.01);
          //max-height: 100vh;
          //min-height:65vh;
          //top:2vh;
          .Title1 {

            //display: block;
            //height: fit-content;
          }
          .Title2 {

            //opacity: 1;
            //max-height: 100vh;
            //min-height: 45vh;
          }
          .backconsult{
            //display: none;
            transform: scale(1.05);
          }
          .backconsultArrow{
            //opacity: 1;
          }
        }
      }

    }
  }
  .screenmake3 {
    padding: 7.78739184177998vh 5.09763142692085vw;
    width: 100%;
    height: fit-content;
    background: #212a3c;
    //background-color: #ebf1fd;
    .heighLight {
      color: white;
      text-align: center;
      height: 7.54017305315204vh;
      font-size: 2.3vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: bold;
      //color: #2168DB;
      line-height: 2.71940667490729vh;
    }

    .grid {
      margin-top: 2.78739184177998vh;

      .card {
        //cursor: pointer;
        margin: 0 auto;
        width: 86%;
        height: 65vh;
        padding: 0.98887515451174vh 0 0.98887515451174vh 0;
        opacity: 1;

        .back {
          border-radius: 9px;
          display: flex;
          position: relative;
          //box-shadow: 5px 0 14px 0px #D4E4FF;
          height: 64vh;
          overflow: hidden;
          background: #19202e;

          .imgDesign {
            width: fit-content;
            height: 100%;
            opacity: 1;
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-color: transparent;
          }

          .titleDesign {
            padding: 1.5248454883vh 1.5248454883vw;
            color: white;
            width: 30vw;
            height: fit-content;
            margin: auto;
            text-align: justify;
            float: right;

            .title1 {
              font-size: 1.3vw;
            }

            .title2 {
              margin-top: 25px;
              line-height: 4vh;
              font-size: 1.1vw;
            }

            .success {
              display: grid;
              grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
              column-gap: 1vw;
              margin-top: 3vh;

              .suc1 {
                width: 100%;
                height: 6vh;

                .title3 {
                  text-align: center;
                  margin-top: 1vh;
                  font-size: 0.8243212016vw;
                }

              }

            }


          }

        }
      }

      ::v-deep .el-carousel__container {
        height: 68vh !important;
      }

      .el-carousel__item h3 {
        color: white;
        opacity: 0.75;
        margin: 0;
      }

      ::v-deep .el-carousel__container {
        position: relative;
        height: 550px;
      }

      ::v-deep .el-carousel__arrow {
        outline: 10vh;
        padding: 0;
        margin: 0;
        cursor: pointer;

        border-radius: 50%;
        width: 55px;
        height: 55px;
        background-color: rgba(249, 250, 252, 0.2);
        border: rgba(255, 255, 255, 0.5) 1px solid;
        color: #fff;
        position: absolute;
        top: 50%;
        z-index: 100;
        transform: translateY(-50%);
        text-align: center;
        font-weight: 800;
        font-size: 25px;
      }
    }
  }
}

.totalModel {
  background: #ebf1fd;
  overflow-x: hidden;
  width: 100vw;
  //height: 100vh;
  position: relative;

  .screen1 {
    z-index: 3;
    position: relative;
    width: 100%;
    height: 460px;
    padding: 2.84301606922126vh 2.86077411900635vw 2.84301606922126vh 2.86077411900635vw;
    background-image: url("../../assets/gptModel11.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: transparent;
    /* Add any additional styling as needed */
    .titlle3 {
      position: absolute;
      bottom: 80px;
      left: 50%;
      transform: translateX(-60%);
      font-size: 17px;
      font-family: arial, sans-serif, "Microsoft Yahei";
      font-weight: 400;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 9.1px;
      width: fit-content;
      margin: 0 15px;
      padding: 10px 25px;
      height: 40px;
      color: white;
      background-color: #2f6eff;
      border: 1px solid #2f6eff;
      overflow: hidden;

    }

    .title4 {
      position: absolute;
      left: 10%;
      bottom: 45px;
      margin: 35px auto 0 auto;
      width: 80%;
      height: 17px;
      font-size: 10px;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: 400;
      color: #111111;
      line-height: 14px;
    }

    .layer2 {
      position: absolute;
      left: 0;

      .title1 {
        margin: 0 auto;
        width: fit-content;
        text-align: center;
        height: 23px;
        font-size: 23px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 500;
        color: #111111;
        line-height: 8.2373300371vh;
      }

      .title2 {
        margin: 35px auto;
        width: 90%;
        text-align: center;
        height: 17px;
        font-size: 14px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #111111;
        line-height: 24px;
      }
    }

  }

  .screenmake0 {
    padding: 20px 4.6875vw;
    width: 100%;
    height: fit-content;
    background: white;

    .heighLight {
      text-align: center;
      height: 21px;
      opacity: 1;
      font-size: 21px;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: 700;
      line-height: 26px;

    }

    .heightLight2 {
      margin: 19px 2vw;
      text-align: justify;
      width: fit-content;
      height: fit-content;
      font-size: 14px;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: 400;
      color: #2C3E50;
      line-height: 20px;
    }

    .grid {

      display: grid;
      grid-template-columns: minmax(0, 1fr);
      column-gap: 1vw;

      .card1 {
        //cursor: pointer;
        width: 100%;
        height: fit-content;
        padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0;
        opacity: 1;

        .back {
          border-radius: 9px;
          position: relative;
          height: fit-content;
          overflow: hidden;
          margin-bottom: 1.5248454883vh;

          .imgDesign {
            text-align: center;
            width: 100%;
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-color: transparent;
          }

          .titleDesign {
            padding: 1.5248454883vh 1.5248454883vw;
            //background-color: #2F6EFF;
            .Title1 {
              color: black;
              text-align: center;
              font-size: 1.1709416522vw;

              font-family: arial, sans-serif, "Microsoft Yahei";
              font-weight: 700;
            }

          }

          .backconsult {
            position: absolute;
            bottom: 1.81248454882571vh;
            text-align: center;
            font-size: 0.8vw;
            font-family: Sarial, sans-serif, "Microsoft Yahei";
            font-weight: 400;
            color: #2168DB;
            align-items: center; /* Vertically center the text */
            justify-content: center; /* Horizontally center the text */
            height: 2.95414091470952vh;
            left: 50%;
            transform: translateX(-50%);

            color: #2168DB;
          }

          .backconsultArrow {
            position: absolute;
            bottom: 1.81248454882571vh;
            text-align: center;
            font-size: 0.8vw;
            font-family: Sarial, sans-serif, "Microsoft Yahei";
            font-weight: 400;
            color: #2168DB;
            align-items: center; /* Vertically center the text */
            justify-content: center; /* Horizontally center the text */
            height: 2.95414091470952vh;
            left: 80%;
            transform: translateX(-50%);
          }

        }


      }

    }
  }

  .screenmake2 {
    padding: 20px 15px;
    width: 100%;
    height: fit-content;
    background: #ebf1fd;

    .heighLight {
      text-align: center;
      height: 21px;
      opacity: 1;
      font-size: 21px;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: 700;
      line-height: 26px;

    }


    .grid {
      margin-top: 2.78739184177998vh;
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      column-gap: 0;
      row-gap: 15px;

      .card {
        cursor: pointer;
        width: fit-content;
        height: fit-content;
        padding: 5px 5px;
        opacity: 1;

        .back {
          border-radius: 9px;
          position: relative;
          box-shadow: 5px 0 14px 0px #D4E4FF;
          height: fit-content;
          overflow: hidden;
          background: white;

          .imgDesign {
            position: absolute;
            transition: transform 0.3s ease-out;
            overflow: hidden;
            width: 100%;
            height: 210px;
            opacity: 1;
            background-image: url("../../assets/gpt13.png");
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-color: transparent;
          }

          .titleDesign {
            .Title1 {
              margin-top: 220px;
              display: flex;
              justify-content: center;
              text-align: center;
              height: 20px;
              font-size: 16px;
              font-family: arial, sans-serif, "Microsoft Yahei";
              font-weight: 700;
              color: #FF6400;
              line-height: 2.7194066749vh;
            }

            .Title2 {
              margin: 14px 12px 45px 12px;
              text-align: justify;
              height: fit-content;
              font-size: 14px;
              font-family: Sarial, sans-serif, "Microsoft Yahei";
              font-weight: 400;
              line-height: 22px;
            }

            .backconsult {
              position: absolute;
              bottom: 15px;
              text-align: center;
              font-size: 14px;
              font-family: Sarial, sans-serif, "Microsoft Yahei";
              font-weight: 400;
              color: #2168DB;
              align-items: center; /* Vertically center the text */
              justify-content: center; /* Horizontally center the text */
              left: 50%;
              transform: translateX(-50%);
              color: #2168DB;
            }

            .backconsultArrow {
              position: absolute;
              bottom: 15px;
              text-align: center;
              font-size: 14px;
              font-family: Sarial, sans-serif, "Microsoft Yahei";
              font-weight: 400;
              color: #2168DB;
              align-items: center; /* Vertically center the text */
              justify-content: center; /* Horizontally center the text */
              left: 60%;
              transform: translateX(-50%);
            }
          }
        }
      }

      .card2 {
        cursor: pointer;
        width: fit-content;
        height: fit-content;
        padding: 5px 5px;
        opacity: 1;

        .back {
          border-radius: 9px;
          position: relative;
          box-shadow: 5px 0 14px 0px #D4E4FF;
          height: fit-content;
          overflow: hidden;
          background: white;

          .imgDesign {
            position: absolute;
            transition: transform 0.3s ease-out;
            overflow: hidden;
            width: 100%;
            height: 240px;
            opacity: 1;
            background-image: url("../../assets/gpt14.png");
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-color: transparent;
          }

          .titleDesign {
            .Title1 {
              margin-top: 250px;
              display: flex;
              justify-content: center;
              text-align: center;
              height: 20px;
              font-size: 16px;
              font-family: arial, sans-serif, "Microsoft Yahei";
              font-weight: 700;
              color: #FF6400;
              line-height: 2.7194066749vh;
            }

            .Title2 {
              margin: 14px 12px 15px 12px;
              text-align: justify;
              height: fit-content;
              font-size: 14px;
              font-family: Sarial, sans-serif, "Microsoft Yahei";
              font-weight: 400;
              line-height: 22px;
            }

            .backconsult {
              position: absolute;
              bottom: 15px;
              text-align: center;
              font-size: 14px;
              font-family: Sarial, sans-serif, "Microsoft Yahei";
              font-weight: 400;
              color: #2168DB;
              align-items: center; /* Vertically center the text */
              justify-content: center; /* Horizontally center the text */
              left: 50%;
              transform: translateX(-50%);
              color: #2168DB;
            }

            .backconsultArrow {
              position: absolute;
              bottom: 15px;
              text-align: center;
              font-size: 14px;
              font-family: Sarial, sans-serif, "Microsoft Yahei";
              font-weight: 400;
              color: #2168DB;
              align-items: center; /* Vertically center the text */
              justify-content: center; /* Horizontally center the text */
              left: 60%;
              transform: translateX(-50%);
            }
          }
        }
      }

      .card1 {
        cursor: pointer;
        width: fit-content;
        height: fit-content;
        padding: 5px 5px;
        opacity: 1;

        .back {
          border-radius: 9px;
          position: relative;
          box-shadow: 5px 0 14px 0px #D4E4FF;
          height: fit-content;
          overflow: hidden;
          background: white;

          .imgDesign {
            position: absolute;
            transition: transform 0.3s ease-out;
            overflow: hidden;
            width: 100%;
            border-top-right-radius: 9px;
            border-top-left-radius: 9px;
            height: 185px;
            opacity: 1;
            background-image: url("../../assets/gpt15.png");
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-color: transparent;
          }

          .titleDesign {
            .Title1 {
              margin-top: 195px;
              display: flex;
              justify-content: center;
              text-align: center;
              height: 20px;
              font-size: 16px;
              font-family: arial, sans-serif, "Microsoft Yahei";
              font-weight: 700;
              color: #FF6400;
              line-height: 2.7194066749vh;
            }

            .Title2 {
              margin: 14px 12px 15px 12px;
              text-align: justify;
              height: fit-content;
              font-size: 14px;
              font-family: Sarial, sans-serif, "Microsoft Yahei";
              font-weight: 400;
              line-height: 22px;
            }

            .backconsult {
              position: absolute;
              bottom: 15px;
              text-align: center;
              font-size: 14px;
              font-family: Sarial, sans-serif, "Microsoft Yahei";
              font-weight: 400;
              color: #2168DB;
              align-items: center; /* Vertically center the text */
              justify-content: center; /* Horizontally center the text */
              left: 50%;
              transform: translateX(-50%);
              color: #2168DB;
            }

            .backconsultArrow {
              position: absolute;
              bottom: 15px;
              text-align: center;
              font-size: 14px;
              font-family: Sarial, sans-serif, "Microsoft Yahei";
              font-weight: 400;
              color: #2168DB;
              align-items: center; /* Vertically center the text */
              justify-content: center; /* Horizontally center the text */
              left: 60%;
              transform: translateX(-50%);
            }
          }
        }
      }
    }
  }

  .screenmake3 {
    //left: 10.86077411900635vw;
    width: 100vw;
    height: fit-content;

    padding: 20px 15px;
    background: black;

    .heighLight {
      text-align: center;
      height: 21px;
      opacity: 1;
      font-size: 21px;
      color: white;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: 700;
      line-height: 26px;
    }

    .heightLight2 {
      margin: 19px 2vw;
      text-align: justify;
      width: fit-content;
      height: fit-content;
      font-size: 14px;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: 400;
      color: #2C3E50;
      line-height: 20px;
    }

    .grid {
      margin-top: 2.78739184177998vh;
      position: relative;

      .card {
        cursor: pointer;
        width: 98%;
        margin: 0 auto;
        min-height: 250px;
        padding: 0 0.69324090121317vw 0 0;
        opacity: 1;
        background: #19202e;

        .back {
          border-radius: 9px;
          position: relative;
          //box-shadow: 5px 0 14px 0px #D4E4FF;
          min-height: 360px;
          overflow: hidden;
          background: #19202e;

          .imgDesign {
            width: 100%;
            height: fit-content;
            opacity: 1;
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-color: transparent;
          }

          .titleDesign {
            padding: 15px 20px 25px 20px;
            color: white;
            width: 100%;
            float: right;

            .title1 {
              margin-top: 15px;
              font-size: 16px;
            }

            .title2 {
              margin-top: 15px;
              line-height: 22px;
              font-size: 14px;

              ::v-deep li {
                margin-top: 5px;
              }
            ;
            }


          }

        }
      }

      ::v-deep .el-carousel__container {
        height: 430px !important;

      }

      .el-carousel__item h3 {
        color: white;
        opacity: 0.75;
        margin: 0;
      }

      .el-carousel__item:nth-child(2n) {
        background-color: transparent;
      }

      .el-carousel__item:nth-child(2n+1) {
        background-color: transparent;
      }

      ::v-deep .el-carousel__arrow {
        display: block;
        //border: 1px solid white;
        outline: -5px;
        padding: 0;
        margin: -68px -10px;
        cursor: pointer;

        border-radius: 0;
        width: 25px;
        height: 48px;
        background: rgba(245, 246, 250, 0.8);
        color: #131313;
        position: absolute;
        top: 50%;
        z-index: 100;
        transform: translateY(-50%);
        text-align: center;
        font-size: 14px;
      }
    }
  }
}
</style>



